<footer fxFlex="100%">
  <span>Copyright 2020 Nils Thingvall</span>
</footer>